import "script-loader!signalr/jquery.signalR.js";
import "script-loader!js-cookie/src/js.cookie.js";

import "script-loader!abp-web-resources/Abp/Framework/scripts/abp.js";
import "script-loader!abp-web-resources/Abp/Framework/scripts/libs/abp.jquery.js";
import "script-loader!abp-web-resources/Abp/Framework/scripts/libs/abp.moment.js";

import {AppConsts} from "./AppConsts";
import "./common/abp.vue.config";
import abpHttp from "./http/AbpHttp";

export default class AppPreBootstrap {
  static isMobile = false;

  static run(callback) {
    AppPreBootstrap.getApplicationConfig(() => {
      AppPreBootstrap.getUserConfiguration(callback);
    });
  }

  //获取配置文件
  static getApplicationConfig(callback) {
    abp
      .ajax({
        url: this.isMobile
          ? "/static/appconfig.mobile.json"
          : "/static/appconfig.json",
        method: "GET"
      })
      .done(result => {
        AppConsts.subDirectory = result.subDirectory;
        AppConsts.appBaseUrl = window.location.origin + result.subDirectory;
        AppConsts.remoteServiceBaseUrl = result.remoteServiceBaseUrl;
        AppConsts.debug = result.debug;
        AppConsts.docExtensions = result.docExtensions;
        AppConsts.videoExtensions = result.videoExtensions;
        AppConsts.scormExtensions = result.scormExtensions;
        AppConsts.home_buttonsCustomized = result.home_buttonsCustomized;
        AppConsts.home_buttons = result.home_buttons;
        AppConsts.home_buttons_align = result.home_buttons_align;
        AppConsts.resource_buttons = result.resource_buttons;
        AppConsts.resource_buttons_align = result.resource_buttons_align;
        AppConsts.wechat_platform = result.wechat_platform;
        AppConsts.cp_wechat_platform = result.cp_wechat_platform;
        AppConsts.yun_localtion = result.yun_localtion;
        AppConsts.enableCustomHome = result.enableCustomHome;
        AppConsts.enableRule = result.enableRule;
        AppConsts.enableZYYHome = result.enableZYYHome;
        AppConsts.wxUrl = result.wxUrl;
        AppConsts.rsa_home_url = result.rsa_home_url;
        AppConsts.show_header = result.show_header;
        AppConsts.page_init_by_category = result.page_init_by_category;
        AppConsts.guest_mode = result.guest_mode;
        AppConsts.show_user_rank = result.show_user_rank;
        AppConsts.show_rank = result.show_rank;
        AppConsts.guest_buttons = result.guest_buttons;
        AppConsts.sany = result.sany;
        AppConsts.company = result.company;
        AppConsts.reportButtons = result.reportButtons;
        AppConsts.dingding_platform = result.dingding_platform
        callback();
      });
  }

  //获取多语言
  static getUserConfiguration(callback) {
    let cookieLangValue = AppConsts.currentLanguage(); // abp.utils.getCookieValue("Language.CultureName");
    // if (cookieLangValue == null) {
    //   cookieLangValue = "zh_CN";
    // }
    $.ajax({
      url: AppConsts.remoteServiceBaseUrl + "common/getAll",
      method: "POST",
      contentType: "application/json",
      headers: {
        Authorization: (abp.auth.getToken() || "").replace("null", ""),
        role: abp.utils.getCookieValue("role")
      },
      data: JSON.stringify({code: cookieLangValue})
    })
      .done(result => {
        abp.utils.setCookieValue(
          "Language.CultureName",
          cookieLangValue,
          new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
          abp.appPath
        );
        AppConsts.languages = result.items.language;
        AppConsts.languageDetails = result.items.languageDetail;
        abp.userInfo = result.items.currentUserInfo;
        AppConsts.site = result.items.settingDto;
        AppConsts.wechat = result.items.wechat;
        moment.locale("cn");
        callback();
      })
      .fail(error => {
        if (error.status == 401) {
          abp.auth.clearToken();
          window.location.reload();
        }
      });
  }

  // static  getSession(callback) {
  //   abpHttp.request("/common/getCurrentUserInfo", {}).then(result => {
  //     abp.userInfo = result.item;
  //     callback();
  //   });
  // }

  static getCurrentClockProvider(currentProviderName) {
    if (currentProviderName === "unspecifiedClockProvider") {
      return abp.timing.unspecifiedClockProvider;
    }

    if (currentProviderName === "utcClockProvider") {
      return abp.timing.utcClockProvider;
    }

    return abp.timing.localClockProvider;
  }
}



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/AppPreBootstrap.js